import type { FeatureToggles } from '../types/reunion';

export interface NavItem {
  label: string;
  path: string;
  featureToggle?: keyof FeatureToggles;
  external?: boolean;
}

export interface NavGroup {
  label: string;
  items: NavItem[];
}

export type NavEntry =
  | { kind: 'link'; item: NavItem }
  | { kind: 'group'; group: NavGroup };

export const AUTH_NAV: NavEntry[] = [
  { kind: 'link', item: { label: 'Dashboard', path: '/dashboard' } },
  {
    kind: 'group',
    group: {
      label: 'Activities',
      items: [
        { label: 'Calendar', path: '/calendar', featureToggle: 'calendarEnabled' },
        { label: 'Schedule', path: '/schedule', featureToggle: 'calendarEnabled' },
        { label: 'Polls', path: '/polls', featureToggle: 'pollsEnabled' },
        { label: 'Bulletin', path: '/bulletin', featureToggle: 'bulletinEnabled' },
      ],
    },
  },
  {
    kind: 'group',
    group: {
      label: 'Community',
      items: [
        { label: 'Directory', path: '/directory', featureToggle: 'directoryEnabled' },
        { label: 'Map', path: '/map', featureToggle: 'mapEnabled' },
      ],
    },
  },
  {
    kind: 'group',
    group: {
      label: 'Services',
      items: [
        { label: 'Shop', path: '/shop', featureToggle: 'shopEnabled' },
        { label: 'Payments', path: '/payments', featureToggle: 'paymentsEnabled' },
        { label: 'Houses', path: '/villas', featureToggle: 'villasEnabled' },
      ],
    },
  },
];

export function getVisibleNav(
  entries: NavEntry[],
  featureToggles?: FeatureToggles,
): NavEntry[] {
  return entries
    .map((entry) => {
      if (entry.kind === 'link') {
        if (entry.item.featureToggle && !featureToggles?.[entry.item.featureToggle]) {
          return null;
        }
        return entry;
      }
      const visibleItems = entry.group.items.filter(
        (item) => !item.featureToggle || featureToggles?.[item.featureToggle],
      );
      if (visibleItems.length === 0) return null;
      return { kind: 'group' as const, group: { ...entry.group, items: visibleItems } };
    })
    .filter((e): e is NavEntry => e !== null);
}
